import React from 'react';
import '../../App.css';

export default function Contact() {
    return <h1 className='contact' style={{ backgroundImage: `url("images/img-8.jpg")`}}>CONTACT</h1>;
}